import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { daoMeGet } from 'dao/iam-dao';
import { Action } from 'types/action';
import { IamState, Me } from 'types/iam';
import { Thunk } from 'types/root';

export const getMeDetails = createAsyncThunk<any, void, Thunk>('me/details', async () => {
  const response = await daoMeGet();
  return response as IamState;
});

const initialState: IamState = {
  isLoading: false,
  me: {} as Me,
};

const iamDetailsSlice = createSlice({
  name: 'me-details',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getMeDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMeDetails.fulfilled, (state, action: Action) => {
        state.me = action.payload;
        state.isLoading = false;
      })
      .addCase(getMeDetails.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default iamDetailsSlice.reducer;
